import { render, staticRenderFns } from "./IpRestriction.vue?vue&type=template&id=6cfb54e3&"
import script from "./IpRestriction.vue?vue&type=script&lang=ts&"
export * from "./IpRestriction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports